export function maskDisplayName(name) {
  const value = String(name || '').trim();
  if (!value) return '***';
  const visible = value.slice(0, 2);
  return `${visible}***`;
}
